module.exports = __webpack_public_path__ + "media/images/vp/sample.practice2-88ecf55117c31c0fe9fc71565ab33e01.jpg";